import React from 'react'
import { Tooltip, Icon } from 'antd'
import styled from '@emotion/styled'

const StyledIcon = styled(Icon)((props) => ({
    color: "#1794FF",
    fontSize: '0.75rem',
	marginLeft: "0.2rem"
}));

const StyledContainer = styled.div`
    display: inline-flex;
    line-height: 1.5rem;
    margin-bottom: ${props => props.maringBottomStyle ? props.maringBottomStyle + "px" : "8px"};
`;

const StyledLabelRequired = styled.label`
    &:before {
        display: inline-block;
        margin-right: 0.2rem;
        color: #f5222d;
        font-size: 0.75rem;
        font-family: SimSun, sans-serif;
        line-height: 1;
        content: '*';
    }
`;

const Label = ({required, htmlFor, value, style}) => {
    if(required){
        return <StyledLabelRequired style={style} htmlFor={htmlFor}>{value}</StyledLabelRequired>
    }
    else {
        return <label style={style} htmlFor={htmlFor}>{value}</label>
    }
}

export const TooltipLabel = ({htmlFor, value, tooltip, fontSizeRem, maringBottomStyle, required}) => {
    return (
      <>
        <StyledContainer maringBottomStyle={maringBottomStyle}>
            <Label 
                style={{fontSize: fontSizeRem + 'rem'}}
                htmlFor={htmlFor}
                value={value}
                required={required}
            />
            {
                !tooltip.hidden &&
                <Tooltip placement="right" title={<div>{tooltip.text}</div>}>
                    <StyledIcon type="info-circle"/>
                </Tooltip>
            }
        </StyledContainer>
      </>
    )
  }